export default function Footer() {
  return (
    <footer id="footer" className="relative bg-secondary-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          <div className="lg:col-span-1">
            <span className="text-xl font-heading font-bold text-primary-600">糖心视频</span>
            <p className="mt-4 text-sm text-foreground-500 leading-relaxed">
              糖心视频提供免费在线影视观看，涵盖西瓜视频免费、免费视频网站91、91在线视频等平台，
              高清不缓冲，热门电影、电视剧、综艺免费追剧。每日更新片库，追剧不迷路。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-foreground-800 mb-4">快捷导航</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '热门推荐', href: '#cards' },
                { label: '专题合集', href: '#index' },
                { label: '焦点速递', href: '#carousel' },
                { label: '热播榜单', href: '#ranking' },
                { label: '常见问题', href: '#faq' },
                { label: '关于我们', href: '#about' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-foreground-800 mb-4">热门标签</h4>
            <div className="flex flex-wrap gap-2">
              {['悬疑剧', '韩剧', '美剧', '国产剧', '科幻片', '纪录片', '动漫', '综艺', '高分电影'].map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1.5 rounded-full bg-background-50 text-xs text-foreground-500 whitespace-nowrap cursor-default"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-foreground-800 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              感谢各影视资源平台与合作伙伴的支持。糖心视频持续拓展合作渠道，欢迎更多优质内容方加入。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 糖心视频 · 免费高清影视在线观看平台
          </p>
          <p className="text-xs text-foreground-400">
            电影大全 · 电视剧全集 · 免费追剧 · 在线不缓冲
          </p>
        </div>
      </div>
    </footer>
  );
}